module.exports = __webpack_public_path__ + "static/media/languages.25a9afb8.png";